import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/back.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-478c9154")

_pushScopeId("data-v-478c9154")
const _hoisted_1 = { class: "back" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "margin-right5px",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "shell" }
const _hoisted_4 = { class: "search-container" }
const _hoisted_5 = { class: "search-form-item" }
const _hoisted_6 = { class: "form-label" }
const _hoisted_7 = { class: "search-form-item" }
const _hoisted_8 = { class: "form-label" }
const _hoisted_9 = { class: "search-form-item" }
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = { class: "search-form-item" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_13 = { class: "batch-project-name" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_secondary_nav = _resolveComponent("secondary-nav")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_pay_processing = _resolveComponent("pay-processing")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.id!=='')
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "margin-bottom20px",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backProject && _ctx.backProject(...args)))
        }, [
          _createVNode("b", _hoisted_1, [
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(`${_ctx.$wordList.ProperAllTextBack}`), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_secondary_nav, {
        navs: _ctx.navs,
        active: _ctx.activeNavItem,
        onChoose: _ctx.changePath
      }, null, 8, ["navs", "active", "onChoose"]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.type==='community'?
                        _ctx.$wordList.ProperAllTextCommunity:_ctx.$wordList.ProperAllOffice), 1),
          _createVNode(_component_cus_select, {
            modelValue: _ctx.listRequestData.param.Community,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listRequestData.param.Community = $event))
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_option, {
                value: "all",
                label: _ctx.$wordList.SelectAll
              }, null, 8, ["label"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectOption, (item) => {
                return (_openBlock(), _createBlock(_component_cus_option, {
                  key: item.ID,
                  value: item.ID,
                  label: item.Name
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$wordList.ProperAllTextType), 1),
          _createVNode(_component_cus_select, {
            modelValue: _ctx.listRequestData.param.Type,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listRequestData.param.Type = $event))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeOptions, (item) => {
                return (_openBlock(), _createBlock(_component_cus_option, {
                  key: item.value,
                  value: item.value,
                  label: item.label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$wordList.ProperAllTextStatus), 1),
          _createVNode(_component_cus_select, {
            modelValue: _ctx.listRequestData.param.Status,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.listRequestData.param.Status = $event))
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (item) => {
                return (_openBlock(), _createBlock(_component_cus_option, {
                  key: item.value,
                  value: item.value,
                  label: item.label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_el_input, {
            class: "width300px",
            modelValue: _ctx.listRequestData.param.Key,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.listRequestData.param.Key = $event)),
            placeholder: _ctx.$wordList.OrderListTanleOrderNumber
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode(_component_cus_button, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateToList++))
        }, {
          default: _withId(() => [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_list_pagination, {
        headers: _ctx.headers,
        requestData: _ctx.listRequestData,
        showDefaultAction: ['info', 'delete'],
        update: _ctx.updateToList,
        saveParamInPath: true,
        showCheck: false,
        deleteUrl: "installdelelteorder",
        action: _ctx.action,
        onInfo: _ctx.goInfo
      }, {
        ProjectsSlot: _withId((data) => [
          _createVNode("div", _hoisted_13, _toDisplayString(data.scope.Projects), 1)
        ]),
        _: 1
      }, 8, ["headers", "requestData", "update", "action", "onInfo"]),
      (_ctx.isShowPayProcessing)
        ? (_openBlock(), _createBlock(_component_pay_processing, {
            key: 0,
            onSuccess: _ctx.successPay,
            "pay-jump-url": _ctx.payJumpUrl
          }, null, 8, ["onSuccess", "pay-jump-url"]))
        : _createCommentVNode("", true)
    ])
  ]))
})